const normalizeLocale = (language: string): string => {
    const normalized = language.replace('_', '-').toLowerCase();

    if (normalized === 'pt' || normalized.startsWith('pt-pt')) return 'pt-PT';
    if (normalized.startsWith('pt-br')) return 'pt-BR';
    if (normalized === 'sv' || normalized.startsWith('sv-')) return 'se';

    return normalized;
};

export const getLang = (): string => {
    const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
    if (stored) return stored;

    if (navigator.languages !== undefined && navigator.languages.length > 0) {
        return normalizeLocale(navigator.languages[0]);
    }

    if (navigator.language !== undefined) return normalizeLocale(navigator.language);

    return 'en';
};
